export default __webpack_public_path__ + "static/media/img-mwa-user-experience-02.4f130d1f.png";